import type { LandingStrings } from './en';

export const zhHant: LandingStrings = {
  header: {
    brandSubtitle: '魔法小店',
    contact: '聯絡我們',
    about: '關於遊戲',
    language: '語言',
  },
  footer: {
    terms: '使用條款',
    privacy: '隱私權政策',
    copyright: '{year} {holder}. 版權所有。',
  },
  home: {
    heroTitle: '一款以藥水和魔法小店為主題的療癒系 3D 遊戲。',
    heroDescription:
      '在一片魔法混亂中尋找材料，用大鍋調製藥水，再放到自己的小店裡販售。',
    features: [
      {
        title: '專屬藥水瓶',
        desc: '瓶身、瓶蓋、藥水顏色——瓶子越漂亮，賣得越貴。',
      },
      {
        title: '有意義的調製',
        desc: '每種藥水都有自己的配方，很多在遊戲裡真的有效果。',
      },
      {
        title: '讓人想一路追下去的故事',
        desc: '奶奶出門度假，把小店交給了你，而一隻名叫莫倫的青蛙找上門來討債。',
      },
      {
        title: '真正屬於你的小店',
        desc: '店裡只賣你親手調製的藥水。',
      },
    ],
    appStore: 'App Store',
    googlePlay: 'Google Play',
    comingSoon: '即將推出',
    tags: { search: '憑影子找材料', craft: '3D 藥水調製', shop: '溫馨小店' },
  },
  about: {
    title: '關於 Qevryno',
    intro: [
      '歡迎來到 Qevryno——一款調製藥水的療癒系遊戲，這裡的魔法都是親手做出來的。',
      '奶奶出門度假了，拜託你幫忙照看她那棟神祕的老房子：被遺忘的配方、魔法材料，還有一口還記得怎麼沸騰的大鍋。樓下有一間小店，整個村子都在猜，現在是誰在顧店。',
      '調製藥水、照顧毛茸茸的使魔、把作品賣給可愛的顧客，再用賺來的金幣佈置你的魔法之家——照自己的步調來，沒有計時器催你。',
    ],
    whatTitle: '這是什麼樣的遊戲？',
    what: [
      'Qevryno 是一款輕鬆紓壓的 3D 解謎遊戲，融合了尋物、鍊金合成和小小的開店模擬。如果你喜歡療癒系遊戲、休閒解謎、找東西的尋物遊戲，或是調製魔藥、鍊金術、經營自己的魔法小店這類遊戲——這款就是為你而做的。',
      '這是一款單人遊戲，不連網也能玩；只有購買和自由選擇觀看的獎勵影片需要網路。沒有橫幅廣告，也沒有彈出式廣告：只有你自己點選領取獎勵時，才會播放一段簡短的 Google AdMob 影片。可選購的項目：寶石，以及看得到內容的材料組合。即將在 iOS 和 Android 推出，支援英文、俄文、西班牙文、德文、法文、荷蘭文、義大利文、葡萄牙文（巴西）、波蘭文、日文、韓文、繁體中文和土耳其文。',
    ],
    doTitle: '你可以做這些事',
    doList: [
      '在魔法 3D 森林空地裡尋找藏起來的材料——每一片空地都像一個小小的微縮場景。',
      '用大鍋調製魔法配方：穩定劑、主要材料、時間香草，再加一抹色彩。',
      '設計專屬藥水瓶——瓶身、瓶蓋、藥水顏色；越漂亮的賣得越貴。',
      '經營自己的小店：顧客、聲望、市集和委託。',
      '追著故事走：奶奶出門度假，把小店交給了你，而一隻名叫莫倫的青蛙老是上門討債。',
      '用研缽磨碎找到的材料，在調和碗裡混合、撒上亮粉——每一種混合物都有自己的質地和顏色。',
      '餵飽使魔，佈置你的小店。',
    ],
    faqTitle: '常見問題',
    faq: [
      { q: 'Qevryno 是免費的嗎？', a: '是的。遊戲免費，不付費也能玩。可選購的項目有寶石和材料組合。' },
      { q: '沒有網路也能玩嗎？', a: '可以。遊戲本身不需要連網——在飛機上或窩在毯子裡都能調製藥水。只有購買和自由選擇觀看的獎勵影片需要網路。' },
      { q: '有廣告嗎？', a: '只有自由選擇觀看的廣告。沒有橫幅廣告，切換畫面時也不會跳出廣告。在少數幾個地方，你可以視需要觀看一段簡短影片來領取獎勵，例如魔力。遊戲裡沒有任何內容要求你一定要看。影片由 Google AdMob 提供，詳細內容可以看我們的「隱私權政策」。' },
      { q: '可以在哪些平台上玩？', a: 'iOS 和 Android，支援英文、俄文、西班牙文、德文、法文、荷蘭文、義大利文、葡萄牙文（巴西）、波蘭文、日文、韓文、繁體中文和土耳其文。' },
      { q: '會很恐怖或很有壓力嗎？', a: '完全不會。這是一款安靜又溫馨的遊戲：輕柔的音樂、犯錯也不會受罰，還有一隻戴帽子的貓。' },
    ],
  },
  contact: {
    title: '聯絡我們',
    subtitle: '對 Qevryno 有疑問、遇到錯誤，或有購買、廣告相關的問題嗎？寫電子郵件給我們吧。',
    write: '寫信給我們',
    mailSubject: 'Qevryno：客服',
    tip: '告訴我們你用的是什麼裝置、發生了什麼事——這樣我們比較容易幫你。',
    info: {
      title: '聯絡資訊',
      email: '電子郵件',
      security: '安全性',
      legalName: '開發者',
      address: '地址',
    },
    refunds: {
      title: '退款與購買',
      description: '所有購買都透過 Apple App Store 或 Google Play 進行。想申請退款，請聯絡應用程式商店：',
      apple: 'Apple App Store',
      appleUrl: 'https://support.apple.com/zh-tw/HT204084',
      google: 'Google Play',
      googleUrl: 'https://support.google.com/googleplay/answer/2479637?hl=zh-TW',
      link: '申請退款',
      note: '我們不會直接收款，也無法辦理退款。如果購買的項目沒有出現在遊戲裡，請打開「設定 → 回復購買」，或寫信給我們。',
    },
  },
  legal: {
    dataController: '資料控管者',
    // Политика и условия есть на английском, русском и испанском; для остальных языков страница показывает английский текст и эту строку
    onlyIn: '本文件僅提供英文、俄文和西班牙文版本，以下為英文版。',
  },
};
